import { render, staticRenderFns } from "./FifthSection.vue?vue&type=template&id=a405f474&scoped=true&"
import script from "./FifthSection.vue?vue&type=script&lang=js&"
export * from "./FifthSection.vue?vue&type=script&lang=js&"
import style0 from "./FifthSection.vue?vue&type=style&index=0&id=a405f474&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a405f474",
  null
  
)

export default component.exports